import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'tenant-item',
  standalone: false,
  templateUrl: './tenant-item.component.html',
  styleUrl: './tenant-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TenantItemComponent {
  public displayName = input<string>('');
  public tenantSlug = input<string>('');
}
